module.exports = __webpack_public_path__ + "static/img/backpack8.e92787b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backpack8.jpg
// module id = 175
// module chunks = 2